export default {
      id: "loading-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#loading",
      toString: function () {
        return this.url;
      }
    }